import { Box, Button, Paper, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import type React from 'react';
import { useNavigate } from 'react-router-dom';

interface TenderTableEmptyStateProps {
  isLoading: boolean;
  hasTenders: boolean;
  primaryButtonStyle: import('@mui/system').SxProps<import('@mui/material/styles').Theme>;
}

const TenderTableEmptyState: React.FC<TenderTableEmptyStateProps> = ({
  isLoading,
  hasTenders,
  primaryButtonStyle,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();

  if (hasTenders) {
    return (
      <Paper
        sx={{
          textAlign: 'center',
          mt: 3,
          p: 3,
          fontStyle: 'italic',
          background: theme.palette.greyLight,
          color: theme.palette.text.primary,
          borderRadius: theme.spacing(1),
        }}
      >
        <Typography>
          {isLoading ? 'Loading tenders...' : 'No tenders match your criteria.'}
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper
      sx={{
        textAlign: 'center',
        mt: 3,
        p: 4,
        background: theme.palette.greyLight,
        color: theme.palette.text.primary,
        borderRadius: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 3,
      }}
    >
      <Typography variant="h6">Ready to add a tender or grant?</Typography>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button
          variant="contained"
          onClick={() => navigate('/tenders/new')}
          sx={{ ...primaryButtonStyle, px: 4, py: 1.5, fontSize: '1.1rem' }}
        >
          + New Tender
        </Button>
        <Button
          variant="contained"
          color="success"
          onClick={() => navigate('/tenders/new', { state: { isGrant: true } })}
          sx={{
            fontWeight: 'bold',
            px: 4,
            py: 1.5,
            fontSize: '1.1rem',
          }}
        >
          + New Grant
        </Button>
      </Box>
    </Paper>
  );
};

export default TenderTableEmptyState;
